exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-label[data-v-d61e2b4a] {\n  display: block;\n  text-align: left;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #1c4c56;\n}\n@media screen and (max-width: 767px) {\n.w-1\\/2[data-v-d61e2b4a] {\n    width: 100%;\n}\n}", ""]);

// exports
